/**
 * Builds the ordering cart with coupons and discounts if they are available.
 *
 * @param {Object}     coupon                  The coupon object to apply to the cart total if it was provided
 * @param {Object}     discount                The discount to be applied to the cart total
 * @param {float|null} complianceFee           The compliance fee if present for the order
 * @param {string}     subtotal                The total amount before any coupons or discounts applied
 * @param {float|null} inHomeCollectionService The in-home collection fee amount when applicable
 */
let buildCouponCart = function (coupon, discount, complianceFee, subtotal, inHomeCollectionService) {
  let couponValue = 0;
  let discountValue = 0;
  var isBaOrder = window.localStorage.getItem('isBaOrder') === 'true';

  setTimeout(function () {
    let validCoupon = coupon && coupon.valid && coupon.discount > 0;
    if (validCoupon && !isBaOrder) {
      couponValue = coupon.discount;
      buildCartRows('.coupon-row', coupon.name, '-$' + couponValue);
    }

    if (discount && !isBaOrder) {
      discountValue = discount.value;
      buildCartRows('.discount-row', discount.name + ' Discount', '-$' + discountValue);
    }

    if ((discount || validCoupon) && !isBaOrder) {
      buildCartRows('.subtotal-row', 'Subtotal', '$' + getParsedAmount(complianceFee, subtotal));
    }

    let totalCartRows = document.querySelectorAll('.total-cart');
    let total = (
      parseFloat(subtotal) -
      couponValue -
      discountValue +
      parseFloat(complianceFee ? complianceFee : '0') +
      parseFloat(inHomeCollectionService ? inHomeCollectionService : '0')
    ).toString();

    for (let i = 0; i < totalCartRows.length; i++) {
      totalCartRows[i].textContent = '$' + getParsedAmount(complianceFee, total);
    }
  }, 800);
};

/**
 * Gets the parsed amount with decimals if a compliance fee is present.
 *
 * @param {float|null} complianceFee The compliance fee in the cart
 * @param {string}     amount        The amount to be parsed
 *
 * @return {string} The parsed amount
 */
let getParsedAmount = function (complianceFee, amount) {
  return complianceFee
    ? parseFloat(amount).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })
    : parseInt(amount).toLocaleString();
};

/**
 * Builds the ordering cart rows with name and value columns.
 *
 * @param {string} rows  The name selector to build the rows.
 * @param {string} name  The name value to place in the first row column
 * @param {string} value The value to place in the item price row column
 */
let buildCartRows = function (rows, name, value) {
  let htmlRows = document.querySelectorAll(rows);
  for (let i = 0; i < htmlRows.length; i++) {
    let nameCell = document.createElement('td');
    nameCell.setAttribute('colspan', '2');
    nameCell.textContent = name;

    let valueCell = document.createElement('td');
    valueCell.setAttribute('class', 'cart-item__price');
    valueCell.textContent = value;

    htmlRows[i].innerHTML = '';
    htmlRows[i].appendChild(nameCell);
    htmlRows[i].appendChild(valueCell);
  }
};

/**
 * Creates a strong element with the coupon text.
 *
 * @param {Object} coupon The coupon object to apply to generate the strong
 *
 * @return {HTMLElement} The strong element
 */
const createStrongCouponText = (coupon) => {
  const couponValue = coupon.type === 'amount' ? `$${coupon.value}` : `${coupon.value}%`;
  const strongCouponText = document.createElement('strong');
  strongCouponText.appendChild(document.createTextNode(`${couponValue} Off ${coupon.name} Coupon`));

  return strongCouponText;
};

/**
 * Creates an anchor link for the coupon.
 *
 * @param {Object} coupon The coupon object to apply to generate the anchor
 *
 * @return {HTMLAnchorElement} The anchor element
 */
const createAnchorLinkForCoupon = (coupon) => {
  let couponTextToAppend = document.createElement('a');
  couponTextToAppend.setAttribute('data-qa-id', 'Coupon Link');
  couponTextToAppend.setAttribute('href', coupon.link);
  couponTextToAppend.setAttribute('target', '_blank');
  couponTextToAppend.appendChild(createStrongCouponText(coupon));

  return couponTextToAppend;
};

/**
 * Creates a coupon alert box with the coupon information.
 *
 * @param {Object} coupon The coupon object to apply to generate the alert box
 *
 * @return {HTMLDivElement} The coupon alert box element
 */
const createCouponAlertBox = (coupon) => {
  const couponAlertBox = document.createElement('div');
  couponAlertBox.setAttribute('data-qa-id', 'Coupon Alert Box');
  couponAlertBox.className = `alert-box coupon text-center ${
    coupon && coupon.name && coupon.name.length > 35 && 'coupon-small-screen-large-text'
  }`;
  couponAlertBox.appendChild(document.createTextNode('Your '));
  couponAlertBox.appendChild(coupon.link ? createAnchorLinkForCoupon(coupon) : createStrongCouponText(coupon));
  couponAlertBox.appendChild(document.createTextNode(coupon.valid ? ' will be applied at checkout.' : ' is expired.'));

  return couponAlertBox;
};

/**
 * Loads cart total with coupons and discounts applied.
 *
 * @param {string}     couponName          The coupon name to apply to the cart total if it was provided
 * @param {string}     tz                  The TZ provided in the url. This is mainly for Testing purposes
 * @param {Object}     discount            The discount to be applied to the cart total.
 * @param {float|null} complianceFee       The total amount before any coupons or discounts applied
 * @param {string}     subtotal            The total amount before any coupons or discounts applied
 * @param {float|null} inHomeCollectionFee The in-home collection fee amount when applicable
 */
window.loadCouponCartTotal = function (couponName, tz, discount, complianceFee, subtotal, inHomeCollectionFee) {
  let coupon = null;

  if (window.localStorage.getItem('isBaOrder') === 'true') {
    $('#coupon-bar').hide();
    $('.alert-box--coupon').addClass('js-hide');
    return;
  }

  $.ajax({
    headers: { 'Browser-Timezone': tz || Intl.DateTimeFormat().resolvedOptions().timeZone },
    url: '/coupon/show',
    method: 'GET',
    async: false,
    dataType: 'json',
    data: { name: couponName },
    success: function (response) {
      // If the coupon was not found by the given name.
      if (!(coupon = response)) {
        return;
      }

      $('.alert-box--coupon').removeClass('js-hide');
      $('#coupon-bar').html(createCouponAlertBox(coupon));
      $('.steps__container').each(function () {
        $(this).removeClass('without-coupon');
      });
      $('.steps').addClass('with-coupon');
    },
    complete: function () {
      if (typeof subtotal === 'string') {
        buildCouponCart(coupon, discount, complianceFee, subtotal.replace(/,/g, ''), inHomeCollectionFee);
      }
    },
  });
};
